// extracted by mini-css-extract-plugin
export default {"logo":"top-bar_logo__S-j+T","theme_icon":"top-bar_theme_icon__pq2r2","upload_button":"top-bar_upload_button__bFXJx"};